(function () {
	const productMediaVideos = document.querySelectorAll(
		'.product__media-list video'
	);

	if (productMediaVideos.length > 0) {
		productMediaVideos.forEach((video) => (video.controls = false));
	}

	const sliders = document.querySelectorAll('.swiper[data-swiper-id]');

	sliders.forEach((slider) => {
		const swiper = new Swiper(
			`.mySwiper[data-swiper-id="${slider.dataset.swiperId}"]`,
			{
				direction: 'horizontal',
				slidesPerView: 'auto',
				lazyLoading: true,
				navigation: {
					nextEl: `.swiper-button-next[data-swiper-id="${slider.dataset.swiperId}"]`,
					prevEl: `.swiper-button-prev[data-swiper-id="${slider.dataset.swiperId}"]`
				},
				pagination: {
					el: `.swiper-pagination[data-swiper-id="${slider.dataset.swiperId}"]`,
					clickable: true
				}
			}
		);
	});

	const menuDrawerItems = document.querySelectorAll(
		"details[id*='Details-menu-drawer-menu-item-']"
	);

	const headerElement = document.querySelector('header.header');

	const headerDrawerBack = document.querySelector('.header-drawer__back--text');

	const headerDrawerBackBtn = document.querySelector(
		'.header-drawer__back--btn'
	);

	menuDrawerItems.forEach((drawerItem) => {
		drawerItem.onclick = () => {
			if (!drawerItem.hasAttribute('open')) {
				headerElement.classList.add('menu-drawer-open');

				headerDrawerBack.textContent = drawerItem.dataset.title;

				headerDrawerBackBtn.setAttribute(
					'data-current',
					drawerItem.dataset.title
				);
			}
		};
	});

	const allProductCardAddToCartBtns = document.querySelectorAll(
		'.product-card-add-to-cart'
	);

	const cartCountBubble = document.querySelector('.cart-count-bubble');

	const cartCountBubbleCount = document.querySelector(
		'.cart-count-bubble__count'
	);

	allProductCardAddToCartBtns.forEach((btn) => {
		btn.onclick = (e) => {
			e.preventDefault();

			let currentBubbleCount = parseInt(cartCountBubbleCount.textContent);

			if (currentBubbleCount === 0) {
				cartCountBubble.classList.remove('cart-count-bubble--empty');
			}

			cartCountBubbleCount.textContent = currentBubbleCount + 1;

			const productId = btn.dataset.productId;

			const formData = {
				items: [
					{
						id: productId,
						quantity: 1
					}
				]
			};

			fetch(window.Shopify.routes.root + 'cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(formData)
			})
				.then((response) => {
					return response.json();
				})
				.catch((error) => {
					console.error('Error:', error);
				});
		};
	});

	const filterBtnOpen = document.querySelector('.custom-filter-btn--open');
	const filterBtnClose = document.querySelectorAll('.custom-filter-btn--close');

	const customFacetsWrapper = document.querySelector('.custom-facets-wrapper');
	const otherFacetsElements = document.querySelectorAll(
		'#FacetFiltersForm > *:not(.custom-facets-wrapper)'
	);

	if (filterBtnOpen) {
		filterBtnOpen.onclick = () => {
			document.body.classList.add('custom-facets-wrapper--open');
			otherFacetsElements.forEach((el) => el.classList.add('facet-inactive'));
			customFacetsWrapper.classList.remove('facet-inactive');
		};
	}

	if (filterBtnClose) {
		filterBtnClose.forEach((btn) => {
			btn.onclick = () => {
				document.body.classList.remove('custom-facets-wrapper--open');
				otherFacetsElements.forEach((el) =>
					el.classList.remove('facet-inactive')
				);
				customFacetsWrapper.classList.add('facet-inactive');
			};
		});
	}

	const customFacetOptionTitles = document.querySelectorAll(
		'.custom-facets-option--title'
	);

	customFacetOptionTitles.forEach((el) => {
		el.onclick = () => {
			if (el.classList.contains('options-open')) {
				el.classList.remove('options-open');
			} else {
				customFacetOptionTitles.forEach((el2) =>
					el2.classList.remove('options-open')
				);

				el.classList.add('options-open');
			}
		};
	});

	const imageWithTextVideo = document.querySelector('.image-with-text--video');
	const imageWithTextVideoPlay = document.querySelectorAll(
		'.image-with-text--play'
	);
	const imageWithTextVideoBtn = document.querySelector(
		'.image-with-text__media .deferred-media__poster-button'
	);

	if (imageWithTextVideo && imageWithTextVideoPlay) {
		imageWithTextVideoPlay.forEach((onplay) => {
			onplay.onclick = () => {
				const videoId = onplay.dataset.videoId;
				const siblings = document.querySelectorAll(
					`.image-with-text--play[data-video-id="${videoId}"]`
				);

				siblings.forEach((el) => {
					if (el.tagName === 'VIDEO') {
						el.play();
						el.classList.add('currently-playing');
					}

					if (el.tagName === 'SPAN') {
						el.style.display = 'none';
					}
				});
			};
		});
	}

	// Show judgeme reviews in percentages
	const jdgmPrevBadges = document.querySelectorAll('.jdgm-prev-badge');

	if (jdgmPrevBadges.length > 0) {
		jdgmPrevBadges.forEach((jdgmPrevBadge) => {
			const updatePrevBadge = () => {
				const badgeText = jdgmPrevBadge.querySelector('.jdgm-prev-badge__text');

				let observer = new MutationObserver(function (mutations) {
					mutations.forEach(function (mutation) {
						if (!/\(\d+\)/.test(mutation.target.textContent.trim())) {
							const reviewsCount = jdgmPrevBadge.dataset.numberOfReviews;

							badgeText.textContent = `(${reviewsCount})`;
						}
					});
				});

				const config = { childList: true, subtree: true, characterData: true };

				observer.observe(badgeText, config);
			};

			updatePrevBadge();
		});
	}

	const allReviewsCounts = document.querySelectorAll(
		'.jdgm-histogram__row[data-frequency][data-percentage]'
	);

	if (allReviewsCounts.length > 0) {
		const updateReviews = () => {
			let reviewsCount = 0;

			allReviewsCounts.forEach((element) => {
				const frequency = parseInt(element.getAttribute('data-frequency'), 10);

				if (!isNaN(frequency)) {
					reviewsCount += frequency;
				}
			});

			allReviewsCounts.forEach((element) => {
				const frequencyTextEl = element.querySelector(
					'.jdgm-histogram__frequency'
				);

				let observer = new MutationObserver(function (mutations) {
					mutations.forEach(function (mutation) {
						if (/^\d+$/.test(Number(mutation.target.textContent.trim()))) {
							const frequency = parseInt(
								element.getAttribute('data-frequency'),
								10
							);

							if (!isNaN(frequency)) {
								const percentage = (frequency / reviewsCount) * 100;
								const frequencyText = `<div class="custom-frequency-percentage"><span>${percentage.toFixed(
									0
								)}%</span> <span>&lpar;${frequency}&rpar;</span></div>`;

								element.querySelector('.jdgm-histogram__frequency').innerHTML =
									frequencyText;
							}
						}
					});
				});

				const config = { childList: true, subtree: true, characterData: true };

				observer.observe(frequencyTextEl, config);
			});
		};

		updateReviews();
	}

	const cloneBagIcon = () => {
		const drawerHeaderBagIcon = document.querySelector(
			'.drawer__header--bag-icon'
		);
		const headerBagIcon = document.querySelector('#cart-icon-bubble');
		const headerBagIconClone = headerBagIcon.cloneNode(true);
		headerBagIconClone.href = 'javascript:void(0);';
		drawerHeaderBagIcon.innerHTML = '';
		drawerHeaderBagIcon.appendChild(headerBagIconClone);
	};

	const updateBagIconInDrawer = () => {
		// Select the target element
		let targetElement = document.querySelector('cart-drawer.drawer');
		let hasHadActive = targetElement.classList.contains('active');

		// Define the callback function
		function callback(mutationsList) {
			for (const mutation of mutationsList) {
				if (
					mutation.type === 'attributes' &&
					mutation.attributeName === 'class'
				) {
					// drawerHeaderBagIcon.innerHTML = '';

					let currentClassState = targetElement.classList.contains('active');

					targetElement = document.querySelector('cart-drawer.drawer');

					if (hasHadActive && !currentClassState) {
						// losing active
						targetElement.removeAttribute('data-is-notification');
					}

					hasHadActive = currentClassState;

					if (currentClassState) {
						cloneBagIcon();

						if (targetElement.hasAttribute('data-is-notification')) {
							const cartItemToShow = document.querySelector(
								`.cart-item[data-product-id="${targetElement.dataset.productNotificationId}"]`
							);

							cartItemToShow.classList.add('cart-item-notification');
						}
					}
				}
			}
		}

		// Create an observer instance
		const observer = new MutationObserver(callback);

		// Configuration of the observer
		const config = { attributes: true, childList: false, subtree: false };

		// Start observing
		observer.observe(targetElement, config);
	};

	const updateIfBagIconEmpty = () => {
		// Select the target element to observe
		const cartDrawer = document.querySelector('cart-drawer.drawer');

		// Define the callback function
		function callback(mutationsList) {
			for (const mutation of mutationsList) {
				if (mutation.type === 'childList') {
					if (cartDrawer.hasAttribute('data-is-notification')) {
						const cartItemToShow = document.querySelector(
							`.cart-item[data-product-id="${cartDrawer.dataset.productNotificationId}"]`
						);

						if (!cartItemToShow.classList.contains('cart-item-notification')) {
							cartItemToShow.classList.add('cart-item-notification');
						}
					}
					// Check if .drawer__header--bag-icon is empty
					// Select the element to check for emptiness
					const bagIcon = document.querySelector('.drawer__header--bag-icon');
					if (!bagIcon.hasChildNodes()) {
						cloneBagIcon();
						// Additional logic can be added here
					}
				}
			}
		}

		// Create an observer instance
		const observer = new MutationObserver(callback);

		// Configuration of the observer
		const config = { childList: true, subtree: true };

		// Start observing
		observer.observe(cartDrawer, config);
	};

	updateBagIconInDrawer();
	updateIfBagIconEmpty();

	// Custom variant color picker
	const variantRadios = document.querySelector(
		'variant-radios:has(input[type="radio"][name="Color"])'
	);

	if (variantRadios) {
		const customSelect = document.querySelector('.variant-color-select-custom');

		const customSelectSelects = document.querySelectorAll(
			'.variant-color-select-custom--select'
		);

		const customSelectOptions = document.querySelectorAll(
			'.variant-color-select-custom--option'
		);

		const variantColorDescriptions = document.querySelectorAll(
			'.variant-color-description'
		);

		const allProductMedia = document.querySelectorAll(
			'.product__media-item[data-variant-name]'
		);

		function handleOutsideClick(event) {
			// Check if the clicked element is not a descendant of any specific div
			if (
				![...customSelectSelects, ...customSelectOptions].some((div) =>
					div.contains(event.target)
				)
			) {
				customSelect.classList.remove('options--open');
			}
		}

		document.addEventListener('click', handleOutsideClick);

		customSelectSelects.forEach((select) => {
			select.onclick = () => {
				if (customSelect.classList.contains('options--open')) {
					customSelect.classList.remove('options--open');
				} else {
					customSelect.classList.add('options--open');
				}
			};
		});

		customSelectOptions.forEach((option) => {
			option.onclick = () => {
				const variant = option.dataset.variant;

				// Get the radio input with the value
				const radioToCheck = variantRadios.querySelector(
					`input[value="${variant}"]`
				);

				// Check the radio input
				radioToCheck.checked = true;

				// Trigger the change event on the custom element
				const event = new Event('change');
				variantRadios.dispatchEvent(event);
			};
		});

		variantRadios.addEventListener('change', () => {
			const checkedInput = variantRadios.querySelector(
				'input[type="radio"][name="Color"]:checked'
			);

			if (checkedInput) {
				const variant = checkedInput.value;

				[...customSelectSelects, ...customSelectOptions].forEach((el) => {
					el.dataset.variant === variant
						? el.classList.add('variant-color-select-custom--active')
						: el.classList.remove('variant-color-select-custom--active');
				});

				[...variantColorDescriptions].forEach((el) => {
					el.dataset.variant === variant
						? el.classList.add('variant-color-description-active')
						: el.classList.remove('variant-color-description-active');
				});

				allProductMedia.forEach((media) =>
					media.classList.remove('variant-current-active')
				);

				const productMediaToShow = document.querySelectorAll(
					`.product__media-item[data-variant-name="${variant}"]`
				);

				productMediaToShow.forEach((media) =>
					media.classList.add('variant-current-active')
				);

				const ingredientsVariants = document.querySelectorAll(
					'.accordion__answer--variant'
				);
				const ingredientsDefault = document.querySelector(
					'.accordion__answer--default'
				);
				const ingredientToShow = document.querySelector(
					`.accordion__answer--variant[data-variant="${variant}"]`
				);

				if (ingredientToShow) {
					[...ingredientsVariants, ingredientsDefault].forEach((el) =>
						el.classList.remove('selected-variant')
					);

					ingredientToShow.classList.add('selected-variant');
				} else {
					if (ingredientsDefault.classList.contains('selected-variant')) {
						return;
					} else {
						[...ingredientsVariants, ingredientsDefault].forEach((el) => {
							if (el) {
								el.classList.remove('selected-variant');
							}
						});

						ingredientsDefault.classList.add('selected-variant');
					}
				}

				// Weight

				const weightVariants = document.querySelectorAll(
					'.product-weight--variant'
				);
				const weightDefault = document.querySelectorAll(
					'.product-weight--regular'
				);
				const weightToShow = document.querySelectorAll(
					`.product-weight--variant[data-variant="${variant}"]`
				);

				if (weightToShow.length > 0) {
					[...weightVariants, ...weightDefault].forEach((el) =>
						el.classList.remove('selected-variant')
					);

					[...weightToShow].forEach((el) =>
						el.classList.add('selected-variant')
					);
				} else {
					if (
						[...weightDefault].some((el) =>
							el.classList.contains('selected-variant')
						)
					) {
						return;
					} else {
						[...weightVariants, ...weightDefault].forEach((el) => {
							if (el) {
								el.classList.remove('selected-variant');
							}
						});

						[...weightDefault].forEach((el) =>
							el.classList.add('selected-variant')
						);
					}
				}

				// pdp-description
				const pdpDescriptionVariants = document.querySelectorAll(
					'.pdp-description--variant'
				);
				const pdpDescriptionDefault = document.querySelectorAll(
					'.pdp-description--default'
				);
				const pdpDescriptionToShow = document.querySelectorAll(
					`.pdp-description--variant[data-variant="${variant}"]`
				);

				if (pdpDescriptionToShow.length > 0) {
					[...pdpDescriptionVariants, ...pdpDescriptionDefault].forEach((el) =>
						el.classList.remove('selected-variant')
					);

					[...pdpDescriptionToShow].forEach((el) =>
						el.classList.add('selected-variant')
					);
				} else {
					if (
						[...pdpDescriptionDefault].some((el) =>
							el.classList.contains('selected-variant')
						)
					) {
						return;
					} else {
						[...pdpDescriptionVariants, ...pdpDescriptionDefault].forEach(
							(el) => {
								if (el) {
									el.classList.remove('selected-variant');
								}
							}
						);

						[...pdpDescriptionDefault].forEach((el) =>
							el.classList.add('selected-variant')
						);
					}
				}
			}

			checkClamping();
		});

		// Shade filter
		const shadeBtns = document.querySelectorAll('.shade-btn');
		const allColors = document.querySelectorAll('.variant-picker-color-custom');
		const allColorsSelect = document.querySelectorAll(
			'.variant-color-select-custom--option'
		);

        let colorsOrdered = [...allColorsSelect].sort(function (a, b) {
            if (a.dataset.variant > b.dataset.variant) {
              return 1;
            }
            if (a.dataset.variant < b.dataset.variant) {
              return -1;
            }
            // a must be equal to b
            return 0;
        })

        colorsOrdered.forEach((color,index) => {
            color.style.order = index
        })

		shadeBtns.forEach((btn) => {
			btn.onclick = () => {
				shadeBtns.forEach((b) => b.classList.remove('shade-btn-selected'));
				btn.classList.add('shade-btn-selected');

				const shade = btn.dataset.shade;

				allColors.forEach((color) =>
					color.classList.remove('variant-picker-color-custom--hidden')
				);

				allColorsSelect.forEach((color) =>
					color.classList.remove('variant-color-select--hidden')
				);

				if (shade !== 'all') {
					const colorsToHide = document.querySelectorAll(
						`.variant-picker-color-custom:not([data-shade="${shade}"])`
					);

					colorsToHide.forEach((color) =>
						color.classList.add('variant-picker-color-custom--hidden')
					);

					const selectToHide = document.querySelectorAll(
						`.variant-color-select-custom--option:not([data-shade="${shade}"])`
					);

					selectToHide.forEach((color) =>
						color.classList.add('variant-color-select--hidden')
					);
				}
			};
		});
	}

	// const colorInputs = document.querySelectorAll(
	// 	'input[type="radio"][name="Color"]'
	// );

	// colorInputs.forEach((input) => {
	// 	input.addEventListener('change', () => {
	// 		const allColorDescriptions = document.querySelectorAll(
	// 			'.variant-color-description'
	// 		);

	// 		allColorDescriptions.forEach((colorDescription) => {
	// 			colorDescription.classList.remove('variant-color-description-active');
	// 		});

	// 		if (input.checked) {
	// 			const colorDescription = document.querySelector(
	// 				`.variant-color-description[data-variant="${input.value}"]`
	// 			);

	// 			colorDescription.classList.add('variant-color-description-active');
	// 		}
	// 	});
	// });

	// window.onload = () => {
	// 	const productInfoHeader = document.querySelector('.product-info-header');
	// 	const productInfoHeaderMobile = document.querySelector(
	// 		'.product-info-header-mobile'
	// 	);

	// 	if (productInfoHeader && productInfoHeaderMobile) {
	// 		// Clone the productInfoHeader element and its child nodes
	// 		const clonedHeader = productInfoHeader.cloneNode(true);

	// 		// Replace the content of productInfoHeaderMobile with the cloned header
	// 		productInfoHeaderMobile.innerHTML = '';
	// 		productInfoHeaderMobile.appendChild(clonedHeader);
	// 	}
	// };

	window.addEventListener('load', function () {
		setTimeout(() => {
			// Get the source and destination elements
			// Get the source and destination elements
			var sourceElement = document.querySelector(
				'.shopify-app-block:has(.jdgm-widget)'
			);
			var destinationElement = document.querySelector(
				'.product-info-header-mobile .product-app-header'
			);

			// Check if the source element exists
			if (sourceElement) {
				// Clone the source element, including its children
				var clonedElement = sourceElement.cloneNode(true);

				// Insert the cloned element at the start of the destination element
				destinationElement.insertBefore(
					clonedElement,
					destinationElement.firstChild
				);
			}
		}, 250);
	});

	const headerMenuLinks = document.querySelectorAll(
		'.header__inline-menu > .list-menu > li > a'
	);
	const allMegaMenus = document.querySelectorAll('.mega-menu');

	headerMenuLinks.forEach((link) =>
		link.addEventListener('mouseenter', () => {
			allMegaMenus.forEach((details) => {
				details.removeAttribute('open');
			});
		})
	);

	// PRODUCT CARD VARIANT PICKERS

	function productCardVariantPickers() {
		// Product card variant picker
		function findGrandparentWithClass(element, className) {
			// Base case: if there is no parent or grandparent, return null
			if (!element || !element.parentElement) {
				return null;
			}

			// Check if the grandparent has the specified class
			if (element.parentElement.classList.contains(className)) {
				return element.parentElement;
			}

			// Recursive call with the parent element
			return findGrandparentWithClass(element.parentElement, className);
		}

		const colorPickerBtns = document.querySelectorAll(
			'.product-card-variant-picker--btn'
		);

		if (colorPickerBtns) {
			colorPickerBtns.forEach((btn) => {
				btn.onclick = () => {
					const variantId = btn.dataset.variantId;
					const variantImage = btn.dataset.variantImage;
					const variantTitle = btn.dataset.variantTitle;

					const cardEl = findGrandparentWithClass(btn, 'card--card');
					const cardImage = cardEl.querySelector('.product-card-img');
					const cardVariantTitle = cardEl.querySelector(
						'.product-card-color-current p'
					);
					const cardVariantInput = cardEl.querySelector(
						'.product-form input[name="id"]'
					);
					const cardBtns = cardEl.querySelectorAll(
						'.product-card-variant-picker--btn'
					);

					cardBtns.forEach((btn2) =>
						btn2.classList.remove('product-card-variant-picker--btn-active')
					);

					btn.classList.add('product-card-variant-picker--btn-active');

					cardImage.srcset = variantImage;
					cardImage.src = variantImage;

					cardVariantTitle.textContent = variantTitle;

					cardVariantInput.value = variantId;
				};
			});
		}

		const productCardDefaultPickers = document.querySelectorAll(
			'.product-card-default-picker'
		);

		if (productCardDefaultPickers) {
			productCardDefaultPickers.forEach((picker) => {
				pickerOptions = picker.querySelector(
					'.product-card-default-picker--options'
				);

				picker.onclick = () => {
					if (
						!pickerOptions.classList.contains(
							'product-card-default-picker--options-open'
						)
					) {
						pickerOptions.classList.add(
							'product-card-default-picker--options-open'
						);
					} else {
						pickerOptions.classList.remove(
							'product-card-default-picker--options-open'
						);
					}
				};

				pickerOptions.onclick = (e) => e.stopPropagation();

				const pickerOptionsBtns = pickerOptions.querySelectorAll('button');
				const currentText = document.querySelector(
					'.product-card-default-picker--current'
				);

				pickerOptionsBtns.forEach((btn) => {
					btn.onclick = () => {
						const currentActiveBtn = document.querySelector(
							'.product-card-default-picker--btn-active'
						);
						currentActiveBtn.classList.remove(
							'product-card-default-picker--btn-active'
						);
						btn.classList.add('product-card-default-picker--btn-active');

						const variantId = btn.dataset.variantId;

						const cardEl = findGrandparentWithClass(btn, 'card--card');
						const cardVariantInput = cardEl.querySelector(
							'.product-form input[name="id"]'
						);

						cardVariantInput.value = variantId;

						currentText.innerHTML = btn.innerHTML;
					};
				});
			});
		}

		function isElementHorizontallyScrollable(element) {
			return element.scrollWidth > element.clientWidth;
		}

		// Get all options containers
		var allOptionsContainers = document.querySelectorAll(
			'.product-card-color-picker--options'
		);

		// Function to check if an element is horizontally scrollable
		function isElementHorizontallyScrollable(element) {
			return element.scrollWidth > element.clientWidth;
		}

		// Function to debounce the resize event
		function debounce(func, wait) {
			let timeout;
			return function executedFunction() {
				const context = this;
				const args = arguments;

				const later = function () {
					timeout = null;
					func.apply(context, args);
				};

				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
			};
		}

		// Function to handle the resize event
		function handleResize() {
			// Iterate over each options container
			allOptionsContainers.forEach(function (optionsContainer) {
				// Check if the options container is not horizontally scrollable
				if (!isElementHorizontallyScrollable(optionsContainer)) {
					// Add class "not-scrollable" to the options container
					optionsContainer.classList.add('not-scrollable');

					// Find the previous and next siblings and add the class to them as well
					var prevSibling = optionsContainer.previousElementSibling;
					var nextSibling = optionsContainer.nextElementSibling;

					if (prevSibling) {
						prevSibling.classList.add('not-scrollable');
					}

					if (nextSibling) {
						nextSibling.classList.add('not-scrollable');
					}
				} else {
					optionsContainer.classList.remove('not-scrollable');

					// Find the previous and next siblings and add the class to them as well
					var prevSibling = optionsContainer.previousElementSibling;
					var nextSibling = optionsContainer.nextElementSibling;

					if (prevSibling) {
						prevSibling.classList.remove('not-scrollable');
					}

					if (nextSibling) {
						nextSibling.classList.remove('not-scrollable');
					}
				}
			});
		}

		handleResize();
		// Debounce the resize event with a 200ms delay
		const debouncedResize = debounce(handleResize, 200);

		// Attach the debounced resize event to the window
		window.addEventListener('resize', debouncedResize);

		var scrollDistance = 28;

		// Get all previous and next buttons
		var prevButtons = document.querySelectorAll(
			'.product-card-color-picker--arrow-prev'
		);
		var nextButtons = document.querySelectorAll(
			'.product-card-color-picker--arrow-next'
		);

		// Initialize scroll functionality for each button
		prevButtons.forEach(function (prevButton) {
			initializeScrollFunctionality(prevButton, -scrollDistance);
		});

		nextButtons.forEach(function (nextButton) {
			initializeScrollFunctionality(nextButton, scrollDistance);
		});

		// Function to initialize scroll functionality for a button
		function initializeScrollFunctionality(button, distance) {
			button.addEventListener('click', function () {
				// Find the closest options container to the button
				var parentElement = button.parentElement;

				// Try to find the next sibling with class .product-card-color-picker--options
				var optionsContainer = parentElement.querySelector(
					'.product-card-color-picker--options'
				);

				// If not found, try to find the previous sibling
				if (!optionsContainer) {
					optionsContainer = parentElement.previousElementSibling;
				}

				// Check if the sibling has the class .product-card-color-picker--options
				if (
					optionsContainer &&
					optionsContainer.classList.contains(
						'product-card-color-picker--options'
					)
				) {
					// Scroll the options container
					optionsContainer.scrollBy(distance, 0);

					// Update button states
					optionsContainer.addEventListener('scroll', function () {
						// Update button states
						updateButtonState(optionsContainer, parentElement);
					});
				}
			});

			var parentElement = button.parentElement;
			var optionsContainer = parentElement.querySelector(
				'.product-card-color-picker--options'
			);

			if (
				optionsContainer &&
				optionsContainer.classList.contains(
					'product-card-color-picker--options'
				)
			) {
				updateButtonState(optionsContainer, parentElement);
			}
		}

		function updateButtonState(optionsContainer, parentElement) {
			// Find the previous and next buttons from the parent
			var prevButton = parentElement.querySelector(
				'.product-card-color-picker--arrow-prev'
			);
			var nextButton = parentElement.querySelector(
				'.product-card-color-picker--arrow-next'
			);

			// If at the beginning of the scroll, add "inactive" class to prev button
			if (optionsContainer.scrollLeft === 0) {
				prevButton.disabled = true;
			} else {
				prevButton.disabled = false;
			}

			// If at the end of the scroll, add "inactive" class to next button
			if (
				optionsContainer.scrollLeft ===
				optionsContainer.scrollWidth - optionsContainer.clientWidth
			) {
				nextButton.disabled = true;
			} else {
				nextButton.disabled = false;
			}
		}

		function debounce(func, wait) {
			let timeout;

			return function executedFunction() {
				const later = function () {
					clearTimeout(timeout);
					func();
				};

				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
			};
		}
	}

	productCardVariantPickers();

	/** Check if there's new grid items */

	// Select the target element you want to observe
	const productGridContainer = document.getElementById('ProductGridContainer');

	if (productGridContainer) {
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.type === 'childList') {
					productCardVariantPickers();
				}
			});
		});

		const config = { childList: true, subtree: true };

		observer.observe(productGridContainer, config);
	}

	/** End check */

	function isTextClamped(element) {
		return element.scrollHeight > element.clientHeight;
	}

	const readMoreBtn = document.querySelector('.pdp-read-more');

	function checkClamping() {
		let textElement = document.querySelector(
			'.pdp-description.selected-variant'
		);

		if (!textElement) {
			textElement = document.querySelector(
				'.pdp-description.pdp-description--default'
			);
		}

		if (isTextClamped(textElement)) {
			readMoreBtn.style.display = 'block';
		} else {
			readMoreBtn.style.display = 'none';
		}
	}

	window.addEventListener('resize', debounce(checkClamping, 250));

	if (readMoreBtn) {
		checkClamping();

		const textContainer = document.querySelector('.pdp');

		readMoreBtn.onclick = () => {
			if (textContainer.classList.contains('expanded')) {
				textContainer.classList.remove('expanded');
				readMoreBtn.innerHTML = 'READ MORE';
			} else {
				textContainer.classList.add('expanded');
				readMoreBtn.innerHTML = 'READ LESS';
			}
		};
	}

	function removeEmptyDataVariantNameAttributes() {
		// Get all elements with the data-variant-name attribute
		const elementsWithAttribute = document.querySelectorAll(
			'[data-variant-name]'
		);

		if (elementsWithAttribute) {
			// Iterate through each element
			elementsWithAttribute.forEach(function (element) {
				// Check if the attribute is empty
				if (!element.getAttribute('data-variant-name')) {
					// Remove the empty data-variant-name attribute
					element.removeAttribute('data-variant-name');
				}
			});
		}
	}

	// Call the function to remove empty data-variant-name attributes
	removeEmptyDataVariantNameAttributes();

	function hideShadeSelectorIfSingleButton() {
		// Get all elements with the class .shade-selector
		var shadeSelectors = document.querySelectorAll('.shade-selector');

		// Iterate through each .shade-selector element
		shadeSelectors.forEach(function (shadeSelector) {
			// Get all child buttons of the current .shade-selector
			var buttons = shadeSelector.querySelectorAll('button');

			// Check if there is only one button
			if (buttons.length === 1) {
				// Hide the .shade-selector
				shadeSelector.style.display = 'none';
			}
		});
	}

	// Call the function to hide .shade-selector if it has a single button
	hideShadeSelectorIfSingleButton();

	function removeElementIfEmptyOptions() {
		// Select the element with the class .variant-color-select-custom--options
		var colorSelectOptions = document.querySelector(
			'.variant-color-select-custom--options'
		);

		// Check if the element is empty
		if (!colorSelectOptions || colorSelectOptions.children.length === 0) {
			// Select and remove the element with the class .variant-radios .product-form__input
			var radiosInput = document.querySelector(
				'variant-radios .product-form__input'
			);

			if (radiosInput) {
				radiosInput.remove();
			}
		}
	}

	// Call the function to remove the element if .variant-color-select-custom--options is empty
	removeElementIfEmptyOptions();

	// Function to check if the footer is wrapping
	function isFooterWrapping() {
		const footer = document.querySelector('.footer-block__details-content');

		if (!footer) {
			console.error('Footer element not found');
			return;
		}

		// Check if the footer is wrapping
		const isWrapping = footer.scrollHeight > footer.clientHeight;
	}

	// Debounce function for window resize
	function debounce(func, wait) {
		let timeout;
		return function () {
			const context = this;
			const args = arguments;
			const later = function () {
				timeout = null;
				func.apply(context, args);
			};
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
		};
	}

	// Function to handle window resize with debounce
	const handleResize = debounce(() => {
		isFooterWrapping();
	}, 300);

	// Event listeners for window resize and load
	window.addEventListener('resize', handleResize);
	window.addEventListener('load', isFooterWrapping);

	// Check if elements in footer are wrapped

	var wrappers = document.querySelectorAll('.footer-block__details-content'); // select flex wrap and wrap-reverse elements

	if (wrappers.length) {
		// don't add listener if no flex elements
		window.addEventListener('resize', function () {
			wrappers.forEach(function (wrapper) {
				var prnt = wrapper,
					chldrn = Array.from(prnt.children).slice(1), // select flex items
					frst = prnt.firstElementChild;

				chldrn.forEach(function (e) {
					e.classList.toggle('flex-wrapped', e.offsetTop !== frst.offsetTop); // element has wrapped
				});

				prnt.classList.toggle(
					'flex-wrapping',
					frst.querySelector('.flex-wrapped') !== null
				); // wrapping has started
				frst.classList.toggle(
					'flex-wrapped',
					chldrn.every(function (e) {
						return !e.classList.contains('flex-wrapped');
					})
				); // all are wrapped
			});
		});

		window.dispatchEvent(new Event('resize')); // lazy way to initially call the above
	}
})();
